import { FilterList } from './types';
import { selectedOptionsByFilterItem } from 'app/area/filters/filters-mapping';

export const mapToDisplaySelectedOptions = (filterList: FilterList[], translation: any, locale?: string) => {
  const result = filterList.reduce(
    (previous: { [indexer: string]: { value: string, label: string, data: FilterList[] } },
      current: FilterList) => {
      const existinOptionItem = previous[current.filter.id];
      if (existinOptionItem) {
        previous[current.filter.id] = {
          ...existinOptionItem,
          data: [...existinOptionItem.data, current]
        };
      } else {
        previous[current.filter.id] = {
          value: current.filter.id,
          label: current.filter.label,
          data: [current]
        };
      }

      return previous;
    }, {});

  return Object.keys(result).map(item => {
    const obj = result[item];

    return {
      value: obj.value,
      label: obj.label,
      selections: selectedOptionsByFilterItem(obj.data.map(value => {
        return {
          ...value, selectedOptions: [...value.selectedOptions]
            .map(code => {
              return {
                ...code,
                value: code.value,
                description: code.description || String(code.value)
              };
            }).sort((a, b) => a.description.localeCompare(b.description, locale))
        };
      }), translation, locale)
    };
  });
};
